import { neutralForegroundRest, neutralForegroundHint, applyScaledTypeRamp, backgroundColor, } from "@fast/fast-components-styles-msft";
import { applyFocusVisible, directionSwitch, format } from "@fast/fast-jss-utilities";
const styles = {
    contentCard: {
        display: "flex",
        position: "relative",
        width: "auto",
        "box-sizing": "border-box",
        "flex-direction": "column",
        outline: "none",
        height: "100%",
        overflow: "hidden",
    },
    contentCard_body: {
        display: "grid",
        "justify-content": "center",
        "row-gap": "8px",
        "column-gap": "10px",
        "grid-template-columns": "1fr auto",
        "grid-template-rows": "auto",
        position: "relative",
    },
    contentCard__default: {
        "& $contentCard_abstract": {
            display: "none",
        },
        "& $contentCard_body, $contentCard__hasAbstract": {
            display: "block",
        },
        "& $contentCard_mediaWrapper": {
            float: directionSwitch("right", "left"),
        },
        "& $contentCard__hasAbstract": {
            "& $contentCard_mediaWrapper": {
                "margin-inline-start": "16px",
            },
            "& $contentCard_abstract": {
                display: "block",
                padding: "0 16px 16px 16px",
            },
        },
        "& $contentCard__hasAbstractFooter": {
            position: "absolute",
            bottom: "0",
            right: "0",
            left: "0",
            background: backgroundColor,
            "box-shadow": format("0px -25px 15px {0}", backgroundColor),
        },
    },
    contentCard_footer: {
        position: "relative",
        "padding-inline-start": "16px",
        "padding-inline-end": "16px",
        "padding-top": "0",
        "padding-bottom": "6px",
        "margin-top": "auto",
        display: "flex",
        "flex-direction": "row",
        "align-items": "center",
        "justify-content": "space-between",
        color: neutralForegroundHint,
        fill: neutralForegroundHint,
    },
    contentCard_footer__hidden: {
        display: "none",
    },
    contentCard_headingContainer: {
        "grid-row": "1",
        display: "flex",
        "flex-direction": "column",
        "padding-inline-start": "16px",
        "padding-inline-end": "16px",
        "padding-bottom": "0",
        "padding-top": "16px",
    },
    contentCard__condensed: {
        "& $contentCard_body": {
            "row-gap": "0",
        },
        "& $contentCard_footer": {
            "grid-row": "2",
            "grid-column": "1",
            "padding-inline-start": "16px",
            "padding-bottom": "0",
        },
        "& $contentCard_mediaWrapper": {
            position: "relative",
            "grid-row": "1 / span 2",
        },
        "& $contentCard_heading": Object.assign(Object.assign({}, applyScaledTypeRamp("t6")), { "-webkit-line-clamp": "2" }),
    },
    contentCard_icon: {
        position: "absolute",
        display: "inline-flex",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "48px",
        height: "48px",
        "justify-content": "center",
        "align-items": "center",
        "border-radius": "50%",
        background: "rgba(0,0,0,0.4)",
        margin: "0 auto",
        "& svg": {
            width: "24px",
            height: "24px",
            fill: "#FFF",
        },
    },
    contentCard_mediaWrapper: {
        position: "relative",
        "grid-row": "1",
        "grid-column": "2",
        "margin-inline-end": "16px",
        "margin-top": "16px",
        height: "fit-content",
    },
    contentCard_imagePriority: {
        "& $contentCard_body": {
            "grid-template-columns": "1",
        },
        "& $contentCard_mediaWrapper": {
            "grid-row": "1",
            "grid-column": "span 2",
            margin: "0",
        },
        "& $contentCard_headingContainer": {
            "grid-row": "2",
            "grid-column": "span 2",
            "padding-top": "4px",
            "padding-inline-start": "16px",
        },
        "& $contentCard_icon": {
            top: "initial",
            left: "0",
            transform: "none",
            bottom: "8px",
            "margin-bottom": "8px",
            "margin-inline-start": "12px",
        },
        "& $contentCard_heading": Object.assign({}, applyScaledTypeRamp("t6")),
        "& $contentCard_media": {
            "& img": {
                "border-radius": "0",
            },
        },
        "& $contentCard__hasAbstract": {
            "& $contentCard_mediaWrapper": {
                "margin-inline-start": "0",
            },
        },
    },
    contentCard_abstract: Object.assign(Object.assign({ position: "relative", margin: "0" }, applyScaledTypeRamp("t7")), { "font-weight": "400", "grid-column": "span 2", "box-sizing": "content-box", color: neutralForegroundHint, padding: "0 16px" }),
    contentCard_heading: Object.assign(Object.assign(Object.assign(Object.assign({ "text-decoration": "none", outline: "none", color: neutralForegroundRest }, applyScaledTypeRamp("t7")), { "font-weight": "600", overflow: "hidden", display: "-webkit-box", "-webkit-line-clamp": "3", "-webkit-box-orient": "vertical", "&:hover": {
            "text-decoration": "underline",
        } }), applyFocusVisible({
        "text-decoration": "underline",
    })), { "&::after": {
            position: "absolute",
            content: "",
            top: "0",
            left: "0",
            right: "0",
            bottom: "0",
        } }),
    contentCard_mask: {
        display: "none",
    },
    contentCard__infoPane: {
        color: neutralForegroundRest,
        "justify-content": "flex-end",
        border: "none",
        "& $contentCard__hasAbstractFooter": {
            position: "absolute",
            bottom: "0",
            right: "0",
            left: "0",
        },
        "& $contentCard__hasAbstract": {
            "grid-template-columns": "1fr 1fr",
            "& $contentCard_headingContainer": {
                "grid-column": "1",
                "grid-row": "1 / span 2",
                "padding-inline-start": "16px",
                "padding-inline-end": "0",
                "padding-bottom": "16px",
                "padding-top": "8px",
            },
            "& $contentCard__hasAbstractFooter": {
                "grid-column": "2",
                "grid-row": "2",
                position: "relative",
            },
        },
        "& $contentCard_headingContainer": {
            "grid-column": "1",
        },
        "& $contentCard_abstract": {
            "grid-column": "2",
            color: neutralForegroundRest,
            padding: "8px 16px 0 16px",
        },
        "& $contentCard_mask": {
            display: "flex",
            position: "absolute",
            top: "0",
            left: "0",
            right: "0",
            bottom: "0",
            background: format("linear-gradient(0deg, {0} 0, transparent 40%)", () => "#000000"),
        },
        "& $contentCard_footer": {
            "margin-top": "unset",
            "grid-row": "2",
            "grid-column": "1 / span 2",
            "padding-inline-start": "16px",
            "padding-inline-end": "16px",
            "padding-top": "4px",
        },
        "& $contentCard_heading": Object.assign(Object.assign({}, applyScaledTypeRamp("t6")), { "-webkit-line-clamp": "2", color: neutralForegroundRest }),
    },
    contentCard__infoPaneSplitVertical: {
        "grid-template-columns": "304px 1fr",
        "grid-template-rows": "auto",
        "& $contentCard_mediaWrapper": {
            "grid-row": "1 / span 2",
            "grid-column": "1",
            margin: "0",
        },
        "& $contentCard_headingContainer": {
            "grid-row": "1",
            "grid-column": "2",
            "padding-inline-start": "4px",
            "padding-inline-end": "16px",
            "padding-bottom": "0",
            "padding-top": "16px",
        },
        "& $contentCard_footer": {
            "grid-row": "2",
            "grid-column": "2",
            "padding-inline-start": "0",
            "padding-inline-end": "16px",
            "padding-top": "0",
            "padding-bottom": "6px",
        },
        "& $contentCard_heading": Object.assign({}, applyScaledTypeRamp("t6")),
        "& $contentCard_media": {
            "& img": {
                "border-radius": "0",
            },
        },
    },
    contentCard__infoPaneSplitHorizontal: {
        "& $contentCard_body": {
            "grid-template-columns": "1fr 1fr",
        },
        "& $contentCard_mediaWrapper": {
            "grid-column": "1 / span 2",
            margin: "0",
        },
        "& $contentCard_headingContainer": {
            "grid-column": "1",
            "grid-row": "2 / span 2",
            "padding-inline-start": "16px",
            "padding-inline-end": "0",
            "padding-bottom": "16px",
            "padding-top": "12px",
        },
        "& $contentCard_footer": {
            "grid-column": "2",
            "grid-row": "2",
            "padding-bottom": "0",
        },
        "& $contentCard_abstract": {
            "grid-column": "2",
            "grid-row": "2",
            padding: "12px 16px 0 16px",
        },
        "& $contentCard_heading": Object.assign({}, applyScaledTypeRamp("t6")),
        "& $contentCard_media": {
            "& img": {
                "border-radius": "0",
            },
        },
        "& $contentCard__hasAbstractFooter": {
            position: "absolute",
            bottom: "0",
            right: "0",
            left: "0",
            background: backgroundColor,
            "box-shadow": format("0px -25px 15px {0}", backgroundColor),
        },
    },
    contentCard_backgroundImage: {
        position: "absolute",
        top: "0",
        left: "0",
        right: "0",
        bottom: "0",
        "& img, & div, & span": {
            width: "100%",
            height: "100%",
            "object-fit": "cover",
        },
    },
    contentCard_media: {
        "& img": {
            "border-radius": "4px",
        },
    },
    contentCard_attribution: {
        color: neutralForegroundRest,
        "padding-bottom": "10px",
    },
    contentCard__hasAbstract: {},
    contentCard_headingWrapper: {},
    contentCard__hasAbstractFooter: {},
    contentCard_startActions: {},
    contentCard_endActions: {},
};
export default styles;
